import React, {Component} from 'react';

import {Trans} from '../../../../../libs/shared/helpers/src/internationalization/react';
import {HandlerOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {DropdownProps} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {DropdownItem} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdownItem';
import {DropdownItemContent} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdownItemContent';
import {CompanyModel} from '../../../../models/api/companyModel';
import {SearchTagModel} from '../../../../models/api/searchTagModel';
import {TagModel} from '../../../../models/api/tagModel';
import {DropdownItemIcon} from '../dropdownItemIcon';
import {DeprecatedSearchDropdown} from '../search/deprecatedSearchDropdown';
import {AsyncDropdownSource, DropdownFetcher} from '../source/asyncDropdownSource';
import {DropdownSource, RowRendererOf} from '../source/dropdownSource';
import {TagDropdownItem} from '../tagDropdownItem';

/*
 * Props.
 */

interface PickParentTagDropdownProps extends DropdownProps {
  company: CompanyModel;
  fetchTagsAsync: DropdownFetcher<SearchTagModel | null>;
  onTagSelect: HandlerOf<SearchTagModel | undefined>;
  selectedTag?: TagModel;
  tag?: TagModel;
}

/*
 * Component.
 */

export class PickParentTagDropdown extends Component<PickParentTagDropdownProps> {
  constructor(props: PickParentTagDropdownProps) {
    super(props);
    this.dropdownSource = new AsyncDropdownSource({
      fetcher: props.fetchTagsAsync,
      renderRow: this.renderRow,
    });
  }

  private readonly dropdownSource: DropdownSource;

  render() {
    return (
      <DeprecatedSearchDropdown
        {...this.props} /* eslint-disable-line react/jsx-props-no-spreading */
        title={<Trans id="dropdown-tag-title">Tags</Trans>}
        height={300}
        source={this.dropdownSource}
      />
    );
  }

  private readonly renderRow: RowRendererOf<SearchTagModel | null> = (
    searchTag,
    index,
    _searchTags,
    isSearching,
  ) => {
    const {onTagSelect, selectedTag} = this.props;

    if (searchTag === null) {
      const isNoneChecked = this.props.selectedTag === undefined;
      return (
        <DropdownItem
          key="no-parent-tag"
          index={index}
          isChecked={isNoneChecked}
          onSelect={() => onTagSelect(undefined)}
        >
          <DropdownItemIcon label={null} iconName="noneSmall" />
          <DropdownItemContent isChecked={isNoneChecked}>
            <Trans id="dropdown-tag-noparenttag">None</Trans>
          </DropdownItemContent>
        </DropdownItem>
      );
    }

    const tag = searchTag[0];
    const isChecked = selectedTag && selectedTag.id === tag.id;
    const nestingLevel = isSearching ? 0 : searchTag.length - 1;
    const tagsPath = isSearching ? searchTag : [];

    return (
      <TagDropdownItem
        tag={tag}
        tagsPath={tagsPath}
        key={tag.id}
        index={index}
        isChecked={isChecked}
        nestingLevel={nestingLevel}
        onSelect={(e) => onTagSelect(searchTag)}
      />
    );
  };
}
